import { FC } from 'react';
import { Avatar as ChAvatar } from '@chakra-ui/react';

type Props = {
  data: {
    name: string,
    src?: string;
  };
  size: "sm" | "md" | "lg" | "xl";
} & any; // TODO: Fix this

export const Avatar: FC<Props> = ({ data, size = "md", ...styles }) => (
  <ChAvatar
    name={data.name}
    size={size}
    src={data?.src}
    {...styles}
  />
)
